module.exports = __webpack_public_path__ + "img/alerts-7.3a4f95e9.gif";